import { render, staticRenderFns, recyclableRender, components } from "./change-password.vue?vue&type=template&id=618d6d16&scoped=true&"
var renderjs
import script from "./change-password.vue?vue&type=script&lang=js&"
export * from "./change-password.vue?vue&type=script&lang=js&"
import style0 from "./change-password.vue?vue&type=style&index=0&id=618d6d16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618d6d16",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/mine/setting/change-password.vue"
export default component.exports